import type { Suggestion } from '../contracts';
import { SearchSuggestionWithType } from '../contracts/SearchSuggestion';

export default function combineSearches({
  recentSearches,
  savedSearches
}: {
  recentSearches: SearchSuggestionWithType[];
  savedSearches: Suggestion[];
}) {
  const savedSearchesLength =
    savedSearches.length < 3 ? savedSearches.length : 3;

  const recentSearchesLength =
    recentSearches.length < 5 ? recentSearches.length : 5;

  return [
    ...savedSearches.slice(0, Math.max(0, 8 - recentSearchesLength)),
    ...recentSearches.slice(0, Math.max(0, 8 - savedSearchesLength))
  ];
}
